import { mapKeys, camelCase } from 'lodash';

import { disconnect } from 'API/SignalR/state/actions';
import * as ConnectionActions from 'State/connection/actions';
import {
  UI_SIDEBAR_ADD_MESSAGE,
  UI_SIDEBAR_CLEAR_MESSAGES,
} from 'Common/UI/state/types';

import * as types from './types';
import {
  SIDEBAR_MESSAGE_STATUS,
  SIDEBAR_MESSAGE_NETWORK_INTERRUPTION,
} from '../../../components/app/sidebar/Constants';

export const setUserInfo = (userInfo, hash) => {
  userInfo = mapKeys(userInfo, (v, k) => camelCase(k));

  return {
    type: types.SECURITY_SET_USER_INFO,
    payload: { userInfo, hash },
  };
};

export const getAccessInfo = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(setAccessInfoLoading(true));
    try {
      const securityResponse = await MPWWebApi.getGeneric('Security');
      const accessInfo = securityResponse.data.Data;
      await dispatch(setAccessInfo(accessInfo));
    } catch (err) {
      //dispatch some error
    }
    dispatch(setAccessInfoLoading(false));
  };
};

export const logOfflineTime = (offlineTimeMessage) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'Logging/Reconnect',
        offlineTimeMessage
      );
    } catch (ex) {}
  };
};

export const setAccessInfo = (value) => ({
  type: types.SECURITY_GET_ACCESS_INFO,
  payload: value,
});

export const setAccessInfoLoading = (value) => {
  return {
    type: types.SECURITY_SET_ACCESS_INFO_LOADING,
    payload: value,
  };
};

const securityLogout = () => ({
  type: types.SECURITY_LOG_OUT,
});

export const logOutAction = () => (dispatch) => {
  dispatch(securityLogout());
  dispatch(disconnect());

  // Set this back to true after logging out since offline is tied to the SignalR connection
  // otherwise it will default the login action to Offline Login
  dispatch(ConnectionActions.setServerUp(true));
  dispatch(ConnectionActions.hideOfflinePrompt());
};

export function clearProgressMessages() {
  return { type: UI_SIDEBAR_CLEAR_MESSAGES };
}

export function dispalyNetworkInteruptionUIMessage() {
  return {
    type: UI_SIDEBAR_ADD_MESSAGE,
    payload: {
      Id: 1,
      Message: {
        Title: SIDEBAR_MESSAGE_NETWORK_INTERRUPTION.Title,
        Description: SIDEBAR_MESSAGE_NETWORK_INTERRUPTION.Description,
      },
      Source: null,
      Status: SIDEBAR_MESSAGE_STATUS.Error,
      Data: null,
    },
  };
}



// WEBPACK FOOTER //
// ./src/common/Security/state/actions.js